var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeptuno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M783.41,210.13h-3.19l45.3-.91-71.75-133.66-70.59,133.66,45.3.91h-4.87v162.25c-55.97,56.73-116.53,90.08-181.69,100.05V210.13h-4.61l45.3-.91-70.59-133.66-70.59,133.66,45.3.91h-4.61v263.44c-62.09-8.42-121.12-40.23-177.09-95.44-1.53-1.53-3.06-3.45-4.59-5.75v-162.25h-3.45l45.3-.91-71.75-133.66-70.59,133.66,45.3.91h-4.61v174.89c0,6.91,2.3,13.05,6.91,18.41,3.83,5.38,9.19,11.5,16.09,18.39,67.47,66.72,140.3,104.28,218.5,112.7v139.05h-215.05v59.81h215.05v215.05h59.81v-215.05h215.05v-59.81h-215.05v-140.19c49.06-6.12,97.36-24.16,144.89-54.06,28.36-17.62,54.05-38.31,77.05-62.09,5.38-5.36,9.59-9.95,12.66-13.8,5.36-5.36,8.05-11.5,8.05-18.41,0-1.53-.39-3.44-1.14-5.75v-169.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeptuno);
export default __webpack_public_path__ + "static/media/Neptuno.494693660cd05fc12440ff424c186719.svg";
export { ForwardRef as ReactComponent };